import React from 'react';
import { ListingObjects } from 'hyperdb-utils';
import { HyperdbListing } from '../../../../hyperdb';

class Listing extends React.Component {
  constructor(props) {
    super(props);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.submitSuccessful && nextProps.savedObject) {
      this.props.api.routing.redirect(this.props.router, `/content/properties/${nextProps.savedObject.id}`);
    }
  }
  render() {
    return (
      <ListingObjects
        { ...this.props }
        deleteMessage="Are you sure you want to delete this content ?"
      />
    );
  }
}

export default HyperdbListing({
  CustomComponent: Listing,
  collectionName: 'property_contents',
  namespace: 'propertyContent',
  mountedUrl: '/content/properties',
  title: 'Contents for properties',
  columns: [
    { attribute: 'name', label: 'property' },
    { label: 'defined', sortable: false, value: (object) => !!object.content.value[1] ? <i className="fas fa-check" /> : null },
  ],
  canCreate: false,
  canDelete: (object) => !!object.content.value[1],
  onEdit: (object, props) => {
    if (!object.content.value[1]) {
      const objectData = {
        id: 0,
        property: { $type: 'reference', external: true, value: ['properties', object.id] },
        website: {},
        email: {},
      };
      props.api.propertyContent.submitCreateForm(objectData);
    } else {
      props.api.routing.redirect(props.router, `/content/properties/${object.content.value[1]}`);
    }
  },
  onDelete: (object, props) => {
    props.api.propertyContent.deleteObject(object.content.value[1]);
  },
});



// WEBPACK FOOTER //
// ./src/frontend/modules/content/property-content/containers/Listing.jsx